/**
 * Los códigos de Firebase Auth, en la lengua del producto.
 *
 * En `core/auth` y no dentro del login porque los leen dos pantallas —entrar y
 * cambiar la contraseña desde el perfil—, y con una tabla por pantalla el mismo
 * fallo acabaría explicándose de dos maneras según por dónde se llegara.
 *
 * Lo que no está en la tabla cae al mensaje de Firebase, que viene en inglés
 * pero dice algo: mejor eso que un «Error desconocido» que no deja ni buscarlo.
 */
export function authErrorCode(err: unknown): string {
  return (err as { code?: string })?.code ?? '';
}

export function friendlyAuthError(err: unknown): string {
  switch (authErrorCode(err)) {
    case 'auth/invalid-credential':
    case 'auth/wrong-password':
    case 'auth/user-not-found':
      return 'Email o contraseña incorrectos.';
    case 'auth/too-many-requests':
      return 'Demasiados intentos. Espera unos minutos.';
    case 'auth/network-request-failed':
      return 'Sin conexión a Firebase. Revisa tu red.';
    case 'auth/invalid-email':
      return 'El email no tiene un formato válido.';
    case 'auth/user-disabled':
      return 'Esta cuenta está deshabilitada.';
    case 'auth/weak-password':
      return 'La contraseña es demasiado débil. Usa una más larga.';
    case 'auth/missing-password':
      return 'Escribe la contraseña.';
    // La sesión lleva demasiado tiempo abierta para una operación sensible.
    // El perfil reautentica antes de cambiar la contraseña, así que aquí sólo
    // se llega si esa reautenticación caducó entre un paso y el siguiente.
    case 'auth/requires-recent-login':
      return 'Por seguridad, vuelve a iniciar sesión antes de cambiar tu contraseña.';
    default:
      return (err as Error)?.message ?? 'Error desconocido';
  }
}
